<div class="master-form" [formGroup]="DirectAddTransForm">
    <div class="row">

        <div class="col-sm-5">
            <label>{{translate.currentLang == 'ar'?'الحركات المعلقة':'Suspended Transaction'}}</label>
            <sanabel-selectize [paginator]="true" appcode="1411" [simpleView]="true"
                (clicked)="addItemsAndForms($event)" #ItemsAndForms>
            </sanabel-selectize>
        </div>
        <div *ngIf="showSuspensionBtn==1" class="col-sm-2" style="margin-top:13px">
            <btns-ctrl #btnCtrl1 [appCodes]="[6907]" [disabled]="DirectAddTransForm.invalid"
                (clicked)="onClicked($event)">
            </btns-ctrl>
        </div>
        <div class="col-sm-2">
            <div class="form-group">
                <label>{{ 'SERIAL' | translate }}</label>
                <input type="text" class="form-control form-control-sm" formControlName="transCode" disabled />
            </div>
        </div>

        <div class="col-sm-2">
            <div class="form-group">
                <label>{{ 'TRANSCODE' | translate }}</label>
                <input type="number" class="form-control form-control-sm" formControlName="tranSerial" disabled />
            </div>
        </div>

        <div class="col-sm-2">
            <label>{{ 'TRANSDATE' | translate }}</label>
            <div class="form-group">
                <div class="input-group input-group-sm">
                    <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}" formControlName="transDate"
                        name="dp" ngbDatepicker #dp="ngbDatepicker" required>
                    <div class="input-group-addon" (click)="dp.toggle()">
                        <i class="fa fa-calendar"></i>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-3">
            <sanabel-selectize [paginator]="true" appcode="1080" formControlName="supplierCode" #supplierCode>
            </sanabel-selectize>
        </div>

        <div class="col-sm-3">
            <label *ngIf="(modeType == 2 || examminationFlag == 1)">{{ 'Store' | translate }}</label>
            <label *ngIf="modeType == 1">{{ 'Pharmacy' | translate }}</label>
            <label *ngIf="modeType == 5">{{ 'THECAFETERIA' | translate }}</label>
            <label *ngIf="modeType == 4">{{ 'BLOODBANK_STORE' | translate }}</label>
            <sanabel-selectize appcode="1245" [simpleView]="true" [SearchKeys]="{Type:modeType}"
                [customPlaceHolder]="placHolder" formControlName="storeCode" #storeByUser></sanabel-selectize>
        </div>
        <div class="col-sm-3">
            <div class="form-group">
                <label>{{ 'HANDNUMBER' | translate }}</label>
                <input type="number" class="form-control form-control-sm" formControlName="handNumber" />
            </div>
        </div>
        <div class="col-sm-3">
            <div class="form-group">
                <label>{{ 'NOTE' | translate }}</label>
                <input type="text" class="form-control form-control-sm" formControlName="notes" />
            </div>
        </div>
        <div class="col-sm-2 col-md-2">
            <div class="form-group">
                <label>{{ 'TOTALSALE' | translate }}</label>
                <input type="text" disabled class="form-control form-control-sm" formControlName="totalSale" />
            </div>
        </div>
        <div class="col-sm-2 col-md-2">
            <div class="form-group">
                <label>{{ "POTOTALTAXMONEY" | translate }}</label>
                <input type="text" disabled class="form-control form-control-sm" numbersOnly
                    formControlName="poTotalTaxMoney" />
            </div>
        </div>
    </div>
</div>
<!--Form-End-->
<p-dataTable tableStyleClass="table table-bordered table-striped cadetblue" [value]="items" [rows]="10"
    [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20,50,100]">
    <p-headerColumnGroup>
        <p-row>
            <p-column header="{{ 'CODE' | translate }}" rowspan="2"></p-column>
            <p-column header="{{ 'PATCHNO' | translate }}" rowspan="2"></p-column>
            <p-column header="{{ 'PATCHNOIN' | translate }}" rowspan="2"></p-column>
            <p-column header="{{ 'ITEMNAME' | translate }}" rowspan="2"></p-column>
            <p-column header="{{ 'UNIT' | translate }}" rowspan="3"></p-column>
            <p-column header="{{ 'COUNT' | translate }}" rowspan="2"></p-column>
            <p-column [hidden]="updateItemCostPrice == 0" header="{{ 'UNITCOST' | translate }}" rowspan="3"></p-column>
            <p-column [hidden]="(addFromDirectExam != 1 || UpdateItemPricePer == 0)" header="تكلفه الوحده بدون مصروف"
                rowspan="3"></p-column>
            <p-column [hidden]="UpdateItemPricePer == 0" header="{{ 'UNITSALE' | translate }}" rowspan="3"></p-column>
            <p-column [hidden]="UpdateItemPricePer == 0" header="{{ 'TOTALITEMSALE' | translate }}" rowspan="3">
            </p-column>
            <p-column [hidden]="updateItemCostPrice == 0" header="{{ 'TOTALITEMCOST' | translate }}" rowspan="3">
            </p-column>
            <p-column header="{{ 'TAX' | translate }}"></p-column>
            <p-column header="{{ 'EXPIRADATE' | translate }}" rowspan="3"></p-column>
            <p-column [hidden]="UpdateItemPricePer == 0" header="{{ 'BALANCE' | translate }}" rowspan="3"></p-column>
            <p-column rowspan="2"></p-column>
        </p-row>
        <p-row>
        </p-row>
    </p-headerColumnGroup>
    <p-column [style]="{ 'font-size':'x-small',
                           'font-style':'normal','font-family':'unset'}" field="customCode">
    </p-column>
    <p-column [style]="{'width': '6%'}" field="patchCode">
        <ng-template pTemplate="options" let-row="rowData" let-rowIndex="rowIndex">
            <input type="text" numbersOnly class="col-sm-12 form-control form-control-sm" [(ngModel)]="row.patchCode"
                name="patchCode" id="tab1{{row['index']}}" [idName]="'tab1'" [tabindex]="row['index']"
                [itemsLength]="items.length" />
        </ng-template>
    </p-column>
    <p-column [style]="{'width': '8%'}" field="patchCodeStr">
        <ng-template pTemplate="options" let-row="rowData" let-rowIndex="rowIndex">
            <input type="text" class="col-sm-12 form-control form-control-sm" [(ngModel)]="row.patchCodeStr"
                name="patchCodeStr" id="tab1{{row['index']}}" [idName]="'tab1'" [tabindex]="row['index']"
                [itemsLength]="items.length" />
        </ng-template>
    </p-column>
    <p-column field="{{translate.currentLang == 'ar'? 'nameAr': 'nameEn'}}">
        <ng-template pTemplate="options" let-row="rowData">
            <i aria-hidden="true" placement="left" ngbTooltip="{{getFactorDesc(row.code)}}">
                <span [ngClass]="{'activeTab': row.errorselected == 1}" style="font-size: x-small;
                              font-style: normal;
                              font-family: unset;
                ">{{translate.currentLang == 'ar'? row.nameAr: row.nameEn }} </span>
            </i>
        </ng-template>
    </p-column>
    <p-column>
        <ng-template pTemplate="options" let-row="rowData">
            <select disabled class="form-control  form-control-sm " id="row.code" (change)="onUnitChange($event ,row)"
                [(ngModel)]="row.unitCode" name="unitCode">
                <option *ngFor="let unit of itemUnits | itemDataFilter: row.code" [value]="unit.serial">
                    {{translate.currentLang == 'ar'? unit.nameAr: unit.nameEn}}
                </option>
            </select>
        </ng-template>
    </p-column>
    <p-column [style]="{'width': '6%'}" field="number">
        <ng-template pTemplate="options" let-row="rowData">
            <input [disabled]="!row.showNumber" type="text" required class="col-sm-12 form-control form-control-sm"
                numbersOnly [(ngModel)]="row.number" name="number" #newNumber (change)="onNuberChange($event ,row)"
                id="tab2{{row['index']}}" [idName]="'tab2'" [tabindex]="row['index']" [itemsLength]="items.length" />
        </ng-template>
    </p-column>
    <p-column [hidden]="updateItemCostPrice == 0" field="unitCost">
        <ng-template pTemplate="options" let-row="rowData">
            <input type="text" class="col-sm-12 form-control form-control-sm" numbersOnly [(ngModel)]="row.unitCost"
                (change)="onNuberChange($event ,row)" name="unitCost" id="tab3{{row['index']}}" [idName]="'tab3'"
                [tabindex]="row['index']" [itemsLength]="items.length" />
        </ng-template>
    </p-column>
    <p-column [hidden]="(addFromDirectExam != 1 || UpdateItemPricePer == 0)" field="unitPrice">
    </p-column>
    <p-column [style]="{'width': '8%'}" [hidden]="UpdateItemPricePer == 0" field="unitSale">
        <ng-template pTemplate="options" let-row="rowData">
            <input type="text" class="col-sm-12 form-control form-control-sm" numbersOnly [(ngModel)]="row.unitSale"
                (change)="onNuberChange($event ,row)" name="unitSale" id="tab4{{row['index']}}" [idName]="'tab4'"
                [tabindex]="row['index']" [itemsLength]="items.length" />
        </ng-template>
    </p-column>
    <p-column [style]="{'width': '8%'}" [hidden]="UpdateItemPricePer == 0" field="netOfPiceitem">
        <ng-template pTemplate="options" let-row="rowData">
            <input [ngClass]="{'activeTab': row.errorselected == 1}" type="text"
                class="col-sm-12 form-control form-control-sm" numbersOnly [(ngModel)]="row.netOfPiceitem" disabled
                name="netOfPiceitem" />
        </ng-template>
    </p-column>
    <p-column [style]="{'width': '8%'}" [hidden]="updateItemCostPrice == 0" field="netOfPiceUnits">
        <ng-template pTemplate="options" let-row="rowData">
            <input [ngClass]="{'activeTab': row.errorselected == 1}" type="text"
                class="col-sm-12 form-control form-control-sm" numbersOnly [(ngModel)]="row.netOfPiceUnits" disabled
                name="netOfPiceUnits" />
        </ng-template>
    </p-column>

    <p-column [style]="{ width: '5%' }" field="itemtaxMoney">
        <ng-template pTemplate="options" let-row="rowData">
            <input type="text" [ngClass]="{ activeTab: row.errorselected == 1 }"
                class="col-sm-12 form-control form-control-sm" numbersOnly [(ngModel)]="row.itemtaxMoney" fraction="2"
                disabled name="itemtaxMoney" />
        </ng-template>
    </p-column>
    <p-column [style]="{'width': '8%'}" field="expirationDate">
        <ng-template pTemplate="options" let-row="rowData">
            <div [hidden]="row['expiry'] != true" class="input-group input-group-sm">
                <input [ngClass]="{'activeTab': row.errorselected == 1}" required class="form-control"
                    placeholder="{{'DATEFORMAT' | translate}}" [(ngModel)]="row.expirationDate" name="dp" ngbDatepicker
                    #dp="ngbDatepicker" (navigate)="expirationDateClick(row)">
                <div class="input-group-addon" (click)="dp.toggle()">
                    <i class="fa fa-calendar"></i>
                </div>
            </div>
        </ng-template>
    </p-column>
    <p-column [style]="{'width': '5%'}" [hidden]="UpdateItemPricePer == 0" field="cardBalanceDiscription">
        <ng-template pTemplate="options" let-row="rowData">
            {{getFactorDesc(row.code)}}
        </ng-template>
    </p-column>
    <p-column [style]="{'width': '3%'}" [sortable]="true">
        <ng-template pTemplate="options" let-row="rowData">
            <icon-action (clicked)="rowIconClick($event,row)" [appCodes]="[!row.showNumber?2158:'',403]"></icon-action>
        </ng-template>
    </p-column>
</p-dataTable>

<div class="container-fluid" [hidden]="showSave == 0">
    <div class="row">
        <div class="col">
            <btns-ctrl #btnCtrl1 [appCodes]="[1,2,6839]" (clicked)="onClicked($event)">
            </btns-ctrl>
        </div>
    </div>
</div>

<style>
    .activeTab {
        background-color: #eaeaea;
        color: #f7022f;
        font-weight: bold;
        font-size: 12px;
    }
</style>